import styled from 'styled-components/macro';
import { colour } from '@notonthehighstreet/toolkit/utils';
import Text from '../Text';

const Link = styled(Text)({ color: colour('cerulean') }).withComponent('a');
Link.displayName = 'Link';

export default Link;
